'use strict';

function ctrl($scope, $http, $location, $window, $resource) {
    let model = this;
    // This object will be filled by the form
    model.user = {};
    // delete any tokens upon visit
    delete $window.sessionStorage.token;
    model.login = function () {
        $http.post(api+'/auth/auth', model.user)
            .success(function (user) {
                $window.sessionStorage.token = user.token;
                if (user.twoAuth) {
                    $location.url('/2step');
                } else {
                    $location.url('/live');
                }
            })
            .error(function (err) {
                console.log(err)
                model.loginerror = 'Error: Invalid user or password';
                // Erase the token if the user fails to log in
                delete $window.sessionStorage.token;
            });
    };
}

ctrl.$inject = ['$scope', '$http', '$location', '$window', '$resource'];
module.exports = ctrl;


/** WEBPACK FOOTER **
 ** ./src/auth/controllers/login.js
 **/